import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AuthenticationService } from '../shared/authentication.service';

@Component({
  selector: 'step-1',
  templateUrl: 'step-1.component.html',
  styleUrls: ['./step-1.component.scss']
})

export class Step1Component implements OnInit {
  model: any = {
    email: null,
    password1: null,
    password2: null,
    acceptedTerms: false
  };
  loading = false;
  errors = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit() { }

  submit() {
    this.loading = true;
    this.errors = [];
    this.authenticationService.register(this.model).subscribe(user => {
      this.loading = false;
      this.router.navigate(['/register/step/2']);
    }, err => {
      this.loading = false;
      this.errors = err;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/register/step-1.component.ts